import moment, {Moment} from 'moment'

export type {Moment}
export default moment

require('moment/min/locales.min')
